import React, { useEffect, useState, useContext } from "react";

import LocalizationContext from "../LocalizationContext";
import CustomizationContext from "../CustomizationContext";

import Grid from "@mui/material/Grid";
import Button from '@mui/material/Button';
import VerifiedIcon from '@mui/icons-material/Verified';
import { Parser } from 'html-to-react';
import FooterFerrettiInfynito from "../Home/FooterFerrettiInfynito";

export const Finish = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [urlMainImage, setUrlMainImage] = useState("");

    const [customizationData, setCustomizationData] = useState({
        idCustomization: "",
        idUtente: "",
        idBasicModel: 0,
        moodType: "",
        language: ""
    });

    const localizationCtx = useContext(LocalizationContext);
    const customizationCtx = useContext(CustomizationContext);


    const startConfiguration = async () => {

        setIsLoading(true);
        const response = await fetch("/api/customization/start/" + props.modelCode + "/" + props.cultureCode);

        if (response.ok) {
            const data = await response.json();
            if (data) {
                customizationCtx.updateCustomizationData(data);
                setCustomizationData(data);
                setIsLoading(false);
                props.updateStepCallBack(1);
            } else {
                setIsLoading(false);
                props.feedbackCallback("error", "Error initializing configuration", true);
            }

        } else {
            setIsLoading(false);
            const error = await response.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }

    }

    const handleStartConfiguration = () => {
        startConfiguration();
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        if (props.modelCode === "Infynito90") {
            setUrlMainImage("/images/Infynito90/main.jpg");
        }

        if (props.modelCode === "Infynito80") {
            setUrlMainImage("/images/Infynito80/main2.jpg");
        }

    }, []);

    return (
        <>
            <div className="content-wrap bkg-deep-ocean">
            <div className="container-fluid bkg-sand">
                <div className="row py-5">
                    <div className="col-12">
                        <p className="infynito-section-subtitle-congratulations text-center py-2"><VerifiedIcon style={{ color: '#FFFFFF', width: '100px', height: '100px' }} />{localizationCtx.localizationData.congratulations}</p>
                        <p className="infynito-section-subtitle text-center py-2">{localizationCtx.localizationData.thanksTitle}</p>
                        <p className="text-infynito-section text-center">{Parser().parse(localizationCtx.localizationData.thanksMessage)}</p>
                    </div>
                </div>
            </div>
            <div className="container-fluid bkg-dark-ocean">
                <div className="row text-center py-5">
                    <div className="col-12">
                        <p className="text-center">
                            <img alt="Main image" className="main-image-congratulations" src={urlMainImage} />
                        </p>
                    </div>
                    <div className="col-12 col-lg-6">
                        <a className="flat-white-button text-uppercase mt-5" onClick={handleStartConfiguration}>{localizationCtx.localizationData.actionStartNew}</a>
                    </div>
                    <div className="col-12 col-lg-6">
                        <a className="flat-white-button text-uppercase mt-5" href="https://www.ferretti-yachts.com">{localizationCtx.localizationData.actionVisitWebsite}</a>
                    </div>
                </div>
                </div>
            </div>
            <FooterFerrettiInfynito cultureCode={props.cultureCode} />
        </>
    );
};

export default Finish;
